import WidgetToComponents from '../../lib/BlockUtils/WidgetToComponents';
import { SectionWithWidgets } from '../../types/api/Sections';

type ContentProps = {
  section: SectionWithWidgets;
};
export function Content({ section }: ContentProps) {
  return WidgetToComponents.getWidgets(section.widgets);
}
